<template lang="pug">
  ul.menu
    li.menu-item(v-for="keyword in list")
      a(@click="$emit('select', keyword)")
        .tile.tile-centered
          .tile-icon
            i.fas.fa-key
          .tile-content.text-ellipsis {{ keyword.keyword }}
    li.menu-item(v-if="!list.length && query && !loading")
      a(@click="$emit('select', {keyword: query})")
        .tile.tile-centered
          .tile-icon
            i.fas.fa-key
          .tile-content.text-ellipsis Adicionar "{{ query }}" como uma nova keyword
</template>

<script>
export default {
  props: {
    list: { type: Array, required: true },
    query: { type: String, required: true },
    loading: { type: Boolean, required: true },
  },
}
</script>

<style lang="stylus" scoped>
.menu
  max-height 200px
  overflow auto
</style>
